var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 480,
    height: 480,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M23.65 24.898c-.998-1.609-1.722-2.943-2.725-5.455C19.229 15.2 31.24 11.366 26.37 3.999c2.111 5.089-7.577 8.235-8.477 12.473-.823 3.898 5.752 8.426 5.757 8.426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M23.878 17.27c-.192 2.516 2.229 3.857 2.299 5.695.056 1.496-1.447 2.743-1.447 2.743s2.728-.536 3.579-2.818c.945-2.534-1.834-4.269-1.548-6.298.267-1.938 6.031-5.543 6.031-5.543s-8.481.562-8.914 6.221"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1565c0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.084 25.055c1.754-.394 3.233.723 3.233 2.01 0 2.901-4.021 5.643-4.021 5.643s6.225-.742 6.225-5.505c0-3.15-3.057-3.937-5.437-2.148m-2.955 2.34s1.941-1.383 2.458-1.902c-4.763 1.011-15.638 1.147-15.638.269 0-.809 3.507-1.638 3.507-1.638s-7.773-.112-7.773 2.181c0 2.39 10.175 2.561 17.446 1.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.935 29.571c-4.509 1.499-12.814 1.02-10.354-.993-1.198 0-2.974.963-2.974 1.889 0 1.857 8.982 3.291 15.63.572z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.686 32.739c-1.636 0-2.695 1.054-2.695 1.822 0 2.391 9.76 2.632 13.627.205l-2.458-1.632c-2.889 1.27-10.146 1.445-8.474-.395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.281 36.632c0-.936-1.055-1.377-1.433-1.588 2.228 5.373-22.317 4.956-22.317 1.784 0-.721 1.807-1.427 3.477-1.093l-1.42-.839C11.26 34.374 9 35.837 9 37.017c0 5.503 27.281 5.238 27.281-.385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 38.604c-4.146 4.095-14.659 5.587-25.231 3.057C24.341 46.164 38.95 43.628 39 38.604"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.683c3dee622a9541d8e41792ca5e1dc6.svg";
export { ForwardRef as ReactComponent };